document.addEventListener("DOMContentLoaded", () => {
  const showBanner = localStorage.showBanner ? localStorage.showBanner : "true";
  // if (showBanner === "true") {
  const banner = document.querySelector(".page-banner");
  const bannerCloseButton = document.querySelector(".page-banner__close");

  if (banner) {
    banner.classList.add("page-banner--visible");
  }

  if (bannerCloseButton) {
    bannerCloseButton.addEventListener("click", () => {
      banner.remove();
      localStorage.showBanner = "false";
    });
  }
  // }

  // localStorage.clear();
});
